<template>
    <div>
        <InvestmentModal v-show="id === 'im'"/>
        <InvestmentSupportModal v-show="id === 'im-s'"/>
        <PerfomanceSupportModal v-show="id === 'pfm-s'"/>
        <ProductInfoModal v-show="id === 'pd-in'"/>
        <BusinessInfoModal v-show="id === 'bi-in'"/>
        <BusinessGrowthModal v-show="id === 'bn-g'"/>
        <PerformanceModal v-show="id === 'pfm'"/>
        <LevelOfBusinessModal v-show="id === 'lb'"/>
        <TypeOfBusinessModal v-show="id === 'tb'"/>
        <ProjectOverview v-show="id === 'po'"/>
    </div>
</template>

<script>
import InvestmentModal from "./InvestmentModal.vue"
import InvestmentSupportModal from "./InvestmentSupportModal.vue"
import PerfomanceSupportModal from "./PerfomanceSupportModal.vue"
import ProductInfoModal from "./ProductInfoModal.vue"
import BusinessInfoModal from "./BusinessInfoModal.vue"
import BusinessGrowthModal from "./BusinessGrowthModal.vue"
import PerformanceModal from "./PerformanceModal.vue"
import LevelOfBusinessModal from "./LevelOfBusinessModal.vue"
import TypeOfBusinessModal from "./TypeOfBusinessModal.vue"
import ProjectOverview from "./ProjectOverview.vue"

export default {
    components:{
        InvestmentModal,
        InvestmentSupportModal,
        PerfomanceSupportModal,
        ProductInfoModal,
        BusinessInfoModal,
        BusinessGrowthModal,
        PerformanceModal,
        LevelOfBusinessModal,
        TypeOfBusinessModal,
        ProjectOverview
    },
    props:['id']
}
</script>